export default __webpack_public_path__ + "static/media/design.f084ca5f.jpg";